import { Directive, ElementRef, HostListener, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { FlexibleConnectedPositionStrategy, Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

import { MenuComponent } from '../components/menu/menu.component';

@Directive({
  selector: '[mcraiMenuTriggerFor]'
})
export class TriggerForDirective implements OnDestroy {
  private _overlayRef: OverlayRef;

  private _menu: MenuComponent;
  @Input() set mcraiMenuTriggerFor(value: MenuComponent) {
    this._menu = value;
  }

  constructor(
    private _overlay: Overlay,
    private _viewContainerRef: ViewContainerRef,
    private _elRef: ElementRef
  ) { }

  ngOnDestroy() {
    this.detachMenu();
  }

  private _getPosition(): FlexibleConnectedPositionStrategy {
    return this._overlay
      .position()
      .flexibleConnectedTo(this._elRef)
      .withPositions([
        { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', weight: 1 },
        { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', weight: 2 },
        { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', weight: 3 },
        { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', weight: 4 }
      ]);
  }

  private _getConfig(): OverlayConfig {
    return new OverlayConfig({
      positionStrategy: this._getPosition()
    });
  }

  private _getPortal(templateRef: TemplateRef<any>): TemplatePortal<any> {
    return new TemplatePortal(templateRef, this._viewContainerRef);
  }

  private _createOverlay(): OverlayRef {
    const config = this._getConfig();

    this._overlayRef = this._overlay.create(config);

    return this._overlayRef;
  }

  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement): void {
    const overlayExists = !!this._overlayRef;
    const overlayIsAttached = overlayExists ? this._overlayRef.hasAttached() : false;
    const triggerIsTarget = this._elRef.nativeElement.contains(targetElement);

    if (triggerIsTarget) {
      this.attachMenu();
    } else {
      if (overlayExists && overlayIsAttached) {
        this.detachMenu();
      }
    }
  }

  public attachMenu(): void {
    const portal = this._getPortal(this._menu.template);

    this._createOverlay().attach(portal);
  }

  public detachMenu(): void {
    if (this._overlayRef) {
      this._overlayRef.dispose();
    }
  }

}
